<template>
  <div class="popper" ref="element">
    <div class="popper__trigger" ref="trigger" @click="triggerClick">
      <slot name="trigger"></slot>
    </div>
    <div :class="joinClasses('popper__popup', modifiers)" ref="popup">
      <slot></slot>
    </div>
    <div v-if="!disableUnderlay" class="popper__underlay" @click="$emit('update:open', false)">
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount, onMounted } from 'vue';
import joinClasses from '@/functions/join_classes';

import Popper from '../../vendor/popper';

const props = defineProps({
  open: { type: Boolean, default: false },
  placement: { type: String, default: 'auto' },
  disabled: Boolean,
  disableUnderlay: { type: Boolean, default: false },
  ignoreTriggerClick: Boolean,
  modifiers: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:open']);

let popperInstance = null;

const element = ref(null);
const trigger = ref(null);
const popup = ref(null);

onMounted(() => {
  popperInstance = new Popper(
    element.value,
    trigger.value,
    popup.value,
    props.placement,
  );

  if (shouldBeOpen()) {
    popperInstance.show();
  }
});

onBeforeUnmount(() => {
  popperInstance.destroy();
});

watch(shouldBeOpen, () => {
  if (!popperInstance) return;
  if (shouldBeOpen()) {
    popperInstance.show();
  } else {
    popperInstance.hide();
  }
});

function shouldBeOpen() {
  return props.open && !props.disabled;
}

function triggerClick() {
  if (props.disabled || props.ignoreTriggerClick) return;

  emit('update:open', true);
}
</script>
